import { render, staticRenderFns } from "./EditBlockConstructor.vue?vue&type=template&id=f0086cf6&scoped=true"
import script from "./EditBlockConstructor.vue?vue&type=script&lang=js"
export * from "./EditBlockConstructor.vue?vue&type=script&lang=js"
import style0 from "./EditBlockConstructor.vue?vue&type=style&index=0&id=f0086cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0086cf6",
  null
  
)

export default component.exports